document.addEventListener('DOMContentLoaded', () => {
    const judgeMeLegacy = document.querySelector('.jdgm-carousel-wrapper');
    const judgeMeCards = document.querySelector('.jdgm-cards-carousel');

    addReadmoreToJudgeMe(judgeMeLegacy, "/products/hey-zomi-menstrual-disc#judgeme_product_reviews");
    addReadmoreToJudgeMe(judgeMeCards, "/products/midi-brief-period-underwear#judgeme_product_reviews");
    
    function addReadmoreToJudgeMe (element, link) {
        if (element) {
            const readMoreBtn = document.createElement('div');
            readMoreBtn.classList.add('read_more_reviews_btn__wrapper');
            readMoreBtn.innerHTML = '<a href="' + link + '" class="btn read_more_reviews">read more reviews</a>';
            element.append(readMoreBtn);
        }
    }
})